module.exports = __webpack_public_path__ + "3209ce1e973cbb43ef73905133505c88.svg";